import { useState, useEffect, ReactNode } from "react";
import LanguageContext from "./LanguageContext";
import en from "../lang/en";
import es from "../lang/es";
import { getLocalStorageValue, setLocalStorageValue } from "@xompass/web-sdk";

const LANGS = {
  en: "en",
  es: "es",
} as const;

type ValidLanguage = keyof typeof LANGS;

const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get("lang");
  const storedLanguage = getLocalStorageValue("globalLanguage");
  const initialLanguage =
    urlLang && Object.keys(LANGS).includes(urlLang)
      ? (urlLang as ValidLanguage)
      : storedLanguage && Object.keys(LANGS).includes(storedLanguage)
        ? (storedLanguage as ValidLanguage)
        : "en";

  const [language, setLanguage] = useState<ValidLanguage>(initialLanguage);
  const [currentLanguage] = useState({
    es: es,
    en: en,
  });

  useEffect(() => {
    setLocalStorageValue("globalLanguage", language);
  }, [language]);

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
        currentLangData: currentLanguage[language],
      }}
    >
      <div
        id="language-context"
        className={`language--${language}`}
        style={{ height: "100%" }}
      >
        {children}
      </div>
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
